import React from 'react';

const input = props => (
    <input {...props} />
);

export default input;